
// ===============================
// Travel Health Insurance Tariff
// ===============================
export const TRAVEL_TARIFF = {
  "Plan A": {
    sumInsured: 100000,
    regions: {
      "Worldwide Excluding USA & Canada": {
        // Each key = Age Band, each value = array of tariffs for days
        
         "0.5-40": [
           { days: 14, premium: 1394 },
          { days: 21, premium: 1453 },
          { days: 28, premium: 1627 },
          { days: 35, premium: 2006 },
          { days: 47, premium: 2298 },
          { days: 60, premium: 2702 },
          { days: 75, premium: 3341 },
          { days: 90, premium: 3994 },
          { days: 120, premium: 6753 },
          { days: 147, premium: 8134 },
          { days: 180, premium: 11301 },
        ],

        "41-50": [
         { days: 14, premium: 2092 },
          { days: 21, premium: 2231 },
          { days: 28, premium: 2490 },
          { days: 35, premium: 3007 },
          { days: 47, premium: 3447 },
          { days: 60, premium: 4083 },
          { days: 75, premium: 5040 },
          { days: 90, premium: 5975 },
          { days: 120, premium: 10197 },
          { days: 147, premium: 12227 },
          { days: 180, premium: 16867 },
        ],
        "51-65": [
           { days: 14, premium: 2812 },
          { days: 21, premium: 2997 },
          { days: 28, premium: 3347 },
          { days: 35, premium: 4042 },
          { days: 47, premium: 4633 },
          { days: 60, premium: 5489 },
          { days: 75, premium: 6775 },
          { days: 90, premium: 8033 },
          { days: 120, premium: 13707 },
          { days: 147, premium: 16440 },
          { days: 180, premium: 22866 },
        ],
        "66-70": [
           { days: 14, premium: 9148 },
          { days: 21, premium: 9752 },
          { days: 28, premium: 10888 },
          { days: 35, premium:  13155 },
          { days: 47, premium: 15078 },
          { days: 60, premium: 17858 },
          { days: 75, premium: 22048 },
          { days: 90, premium: 26136 },
          { days: 120, premium: 0 },
          { days: 147, premium: 0 },
          { days: 180, premium: 0 },
        ],
        "71-75": [
           { days: 14, premium: 16009 },
          { days: 21, premium: 17066 },
          { days: 28, premium: 19053 },
          { days: 35, premium: 23020 },
          { days: 47, premium: 26386 },
          { days: 60, premium: 31252 },
          { days: 75, premium: 38584 },
          { days: 90, premium: 45738 },
          { days: 120, premium: 0 },
          { days: 147, premium: 0 },
          { days: 180, premium: 0 },
        ],
        "76-79": [
           { days: 14, premium: 32017 },
          { days: 21, premium: 34132 },
          { days: 28, premium: 38106 },
          { days: 35, premium: 46041 },
          { days: 47, premium: 52772 },
          { days: 60, premium: 62503 },
          { days: 75, premium: 77169 },
          { days: 90, premium: 91478 },
          { days: 120, premium: 0 },
          { days: 147, premium: 0 },
          { days: 180, premium: 0 },
        ],
      },
      "Worldwide Including USA & Canada": {
        "0.5-40": [
           { days: 14, premium: 2553 },
          { days: 21, premium: 2712 },
          { days: 28, premium: 3065 },
          { days: 35, premium: 3681 },
          { days: 47, premium: 4389 },
          { days: 60, premium: 7070 },
          { days: 75, premium: 10166 },
          { days: 90, premium: 12234 },
          { days: 120, premium: 17235 },
          { days: 147, premium: 22885 },
          { days: 180, premium: 30307 },
        ],

        "41-50": [
         { days: 14, premium: 4725 },
          { days: 21, premium: 5061 },
          { days: 28, premium: 5864 },
          { days: 35, premium: 6918 },
          { days: 47, premium: 8435 },
          { days: 60, premium: 13705 },
          { days: 75, premium: 19820 },
          { days: 90, premium: 23826 },
          { days: 120, premium: 33737 },
          { days: 147, premium: 49161 },
          { days: 180, premium: 59631 },
        ],
        "51-65": [
           { days: 14, premium: 5998 },
          { days: 21, premium: 6426 },
          { days: 28, premium: 7445 },
          { days: 35, premium: 8784 },
          { days: 47, premium: 10710 },
          { days: 60, premium: 17404 },
          { days: 75, premium: 25169 },
          { days: 90, premium: 30256 },
          { days: 120, premium: 42840 },
          { days: 147, premium: 57031 },
          { days: 180, premium: 75721 },
        ],
        "66-70": [
           { days: 14, premium: 19517 },
          { days: 21, premium: 20910 },
          { days: 28, premium: 24223 },
          { days: 35, premium:  28579 },
          { days: 47, premium: 34850 },
          { days: 60, premium: 56631 },
          { days: 75, premium: 81895 },
          { days: 90, premium: 98451 },
          { days: 120, premium: 0 },
          { days: 147, premium: 0 },
          { days: 180, premium: 0 },
        ],
        "71-75": [
           { days: 14, premium: 34155 },
          { days: 21, premium: 36593 },
          { days: 28, premium: 42390 },
          { days: 35, premium: 50013 },
          { days: 47, premium: 60987 },
          { days: 60, premium: 99105 },
          { days: 75, premium: 143316 },
          { days: 90, premium: 172288 },
          { days: 120, premium: 0 },
          { days: 147, premium: 0 },
          { days: 180, premium: 0 },
        ],
        "76-79": [
           { days: 14, premium: 68309 },
          { days: 21, premium: 73186 },
          { days: 28, premium: 84780 },
          { days: 35, premium: 100025 },
          { days: 47, premium: 121975 },
          { days: 60, premium: 198210 },
          { days: 75, premium: 286632 },
          { days: 90, premium: 344577 },
          { days: 120, premium: 0 },
          { days: 147, premium: 0 },
          { days: 180, premium: 0 },
        ],
      },
    },
  },

  "Plan B": {
    sumInsured: 50000,
    regions: {
      "Worldwide Excluding USA & Canada": {
        "0.5-40": [
          { days: 14, premium: 1115 },
          { days: 21, premium: 1162 },
          { days: 28, premium: 1301 },
          { days: 35, premium: 1605 },
          { days: 47, premium: 1838 },
          { days: 60, premium: 2162 },
          { days: 75, premium: 2673 },
          { days: 90, premium: 3195 },
          { days: 120, premium: 5403 },
          { days: 147, premium: 6507 },
          { days: 180, premium: 9041 },
        ],
        "41-50": [
           { days: 14, premium: 1674 },
          { days: 21, premium: 1785 },
          { days: 28, premium: 1992 },
          { days: 35, premium: 2406 },
          { days: 47, premium: 2757 },
          { days: 60, premium: 3266 },
          { days: 75, premium: 4032 },
          { days: 90, premium: 4780 },
          { days: 120, premium: 8157 },
          { days: 147, premium: 9782 },
          { days: 180, premium: 13493 },
        ],
        "51-65": [
           { days: 14, premium: 2249 },
          { days: 21, premium: 2398 },
          { days: 28, premium: 2678 },
          { days: 35, premium: 3233 },
          { days: 47, premium: 3707 },
          { days: 60, premium: 4391 },
          { days: 75, premium: 5420 },
          { days: 90, premium: 6426 },
          { days: 120, premium: 10966 },
          { days: 147, premium: 13152 },
          { days: 180, premium:18293 },
        ],
        "66-70": [
           { days: 14, premium: 7318 },
          { days: 21, premium: 7801 },
          { days: 28, premium: 8710 },
          { days: 35, premium:  10523 },
          { days: 47, premium: 12062 },
          { days: 60, premium: 14286 },
          { days: 75, premium: 17638 },
          { days: 90, premium: 20909 },
          { days: 120, premium: 0 },
          { days: 147, premium: 0 },
          { days: 180, premium: 0 },
        ],
        "71-75": [
           { days: 14, premium: 12807 },
          { days: 21, premium: 13652 },
          { days: 28, premium: 15243 },
          { days: 35, premium: 18416 },
          { days: 47, premium: 21109 },
          { days: 60, premium: 25001 },
          { days: 75, premium: 30867 },
          { days: 90, premium: 36591 },
          { days: 120, premium: 0 },
          { days: 147, premium: 0 },
          { days: 180, premium: 0 },
        ],
        "76-79": [
           { days: 14, premium: 25614 },
          { days: 21, premium: 27304 },
          { days: 28, premium: 30486 },
          { days: 35, premium: 36832 },
          { days: 47, premium: 42217 },
          { days: 60, premium: 50002 },
          { days: 75, premium: 61733 },
          { days: 90, premium: 73181 },
          { days: 120, premium: 0 },
          { days: 147, premium: 0 },
          { days: 180, premium: 0 },
        ],
      },
      "Worldwide Including USA & Canada": {
        "0.5-40": [
          { days: 14, premium: 2042 },
          { days: 21, premium: 2170 },
          { days: 28, premium: 2452 },
          { days: 35, premium: 2944 },
          { days: 47, premium: 3511 },
          { days: 60, premium: 5656 },
          { days: 75, premium: 8133 },
          { days: 90, premium: 9787 },
          { days: 120, premium: 13788 },
          { days: 147, premium: 18307 },
          { days: 180, premium: 24245 },
        ],
       
        "41-50": [
           { days: 14, premium: 3780 },
          { days: 21, premium: 4049 },
          { days: 28, premium: 4691 },
          { days: 35, premium: 5534 },
          { days: 47, premium: 6747 },
          { days: 60, premium: 10964 },
          { days: 75, premium: 16119 },
          { days: 90, premium: 19060 },
          { days: 120, premium: 26989 },
          { days: 147, premium: 35929 },
          { days: 180, premium: 47705 },
        ],
        "51-65": [
          { days: 14, premium: 4798 },
          { days: 21, premium: 5141 },
          { days: 28, premium: 5956 },
          { days: 35, premium: 7027 },
          { days: 47, premium: 8568 },
          { days: 60, premium: 13923 },
          { days: 75, premium: 20135 },
          { days: 90, premium: 24205 },
          { days: 120, premium: 34272 },
          { days: 147, premium: 45625 },
          { days: 180, premium: 60577 },
        ],
        "66-70": [
           { days: 14, premium: 15614 },
          { days: 21, premium: 16725 },
          { days: 28, premium: 19378 },
          { days: 35, premium:  22862 },
          { days: 47, premium: 27879 },
          { days: 60, premium: 45305 },
          { days: 75, premium: 65516 },
          { days: 90, premium: 78760 },
          { days: 120, premium: 0 },
          { days: 147, premium: 0 },
          { days: 180, premium: 0 },
        ],
        "71-75": [
           { days: 14, premium: 27324 },
          { days: 21, premium: 29273 },
          { days: 28, premium: 33911 },
          { days: 35, premium: 40009 },
          { days: 47, premium: 48789 },
          { days: 60, premium: 79284 },
          { days: 75, premium: 114653 },
          { days: 90, premium: 137831 },
          { days: 120, premium: 0 },
          { days: 147, premium: 0 },
          { days: 180, premium: 0 },
        ],
        
      "76-79": [
           { days: 14, premium: 54648 },
          { days: 21, premium: 58547 },
          { days: 28, premium: 67822 },
          { days: 35, premium: 80019 },
          { days: 47, premium: 97578 },
          { days: 60, premium: 1588568 },
          { days: 75, premium: 229306 },
          { days: 90, premium: 275662 },
          { days: 120, premium: 0 },
          { days: 147, premium: 0 },
          { days: 180, premium: 0 },
        ],
      },
    },
  },
};

